import { initHeaderInteractions } from './modules/header-interactions.js';
import { initSrcLazyLoad } from './modules/src-lazyload.js';
import { initSingleInteractions } from './modules/single-interactions.js';
import { initYoutube, initRowDots } from './modules/youtube-videos';
import { initSidebarInteractions } from './modules/sidebar-interactions.js';
import { initScrollInteractions } from './modules/scroll-interactions.js';
import { initCarFinder } from './modules/car-finder.js';
import { initUIHelpers } from './modules/ui-helpers.js';
import { initGalleryImages } from './modules/gallery-images.js';
import { initWpBlockGallery } from './modules/wp-block-gallery.js';

document.addEventListener('DOMContentLoaded', async () => {
    initHeaderInteractions();
    initSrcLazyLoad();
    initScrollInteractions();
    initUIHelpers();

    if (document.body.classList.contains('single')) {
        initSingleInteractions();
    }

    if (document.querySelector('.sidebar')) {
        initSidebarInteractions();
    }

    if (document.querySelector('#youtube-videos')) {
        initYoutube();
        initRowDots();
    }

    if (document.querySelector('#car_finder, #car_finder_filter, #filter_form')) {
        initCarFinder();
    }

    // Render [gallerij] shortcode galleries before binding Fancybox, so the
    // generated [data-fancybox] spans exist when the check below runs.
    if (document.querySelector('.gallery-wrapper')) {
        initGalleryImages();
    }

    // Tag core gallery blocks (.wp-block-gallery) with [data-fancybox] too.
    if (document.querySelector('.wp-block-gallery')) {
        initWpBlockGallery();
    }

    if (document.querySelector('[data-fancybox]')) {
        try {
            const [{ Fancybox }] = await Promise.all([
                import("@fancyapps/ui/dist/fancybox/fancybox.esm.js"),
                import("@fancyapps/ui/dist/fancybox/fancybox.css"),
            ]);

            Fancybox.bind("[data-fancybox]");
        } catch (error) {
            // The lazy chunk or its stylesheet failed to load (flaky network, browser
            // extension, user navigated away). Vite surfaces this as
            // "Unable to preload CSS for ...". Leave [data-fancybox] links as plain
            // links instead of throwing an unhandled rejection.
        }
    }
});
